import React from 'react';
import StatusTag, { buildPlainTooltip, buildStateTooltip, HealthStatus } from '@/components/shared/Tags';
import { HealthStatusKey } from '@core/utils/statusUtils';
import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '@core/store';

export type { HealthStatusKey };

interface HealthStatusCellProps {
    healthStatus: HealthStatusKey;
    name?: string;
    variant?: 'shop' | 'device';
    errorMessage?: string;
}

const HealthStatusCell: React.FC<HealthStatusCellProps> = ({
    healthStatus,
    name = '',
    variant = 'device',
    errorMessage
}) => {
    const { t } = useTranslation();
    const { isMobile } = useSettingsStore();

    let tagConfig = null;
    if (healthStatus === 'Unhealthy') tagConfig = HealthStatus.UnHealthy;
    if (healthStatus === 'Check') tagConfig = HealthStatus.Check;
    if (healthStatus === 'Healthy') tagConfig = HealthStatus.Healthy;
    if (healthStatus === 'Unknown') tagConfig = HealthStatus.Unknown;

    if (!tagConfig) return null;
    if (!healthStatus) return <StatusTag config={tagConfig} />;

    const tooltip =
        variant === 'shop'
            ? buildPlainTooltip(t(`healthStatusTooltip.${healthStatus.toLowerCase()}`))
            : buildStateTooltip(name, healthStatus, t, errorMessage);

    return <StatusTag config={tagConfig} tooltip={tooltip} tooltipPlacement={isMobile ? 'bottom' : 'right'} />;
};

export default HealthStatusCell;
